import { useState, useEffect } from 'react';
import { useAuth } from '../contexts';
import { ADMIN_ROLE_IDS } from '../enums/UserRoleId.enum';

export const useTableDebug = () => {
  const [isDebugVisible, setIsDebugVisible] = useState<boolean>(false);
  const [apiDocumentation, setApiDocumentation] = useState<any>(null);
  const [sqlDocumentation, setSqlDocumentation] = useState<any>(null);
  const { user } = useAuth();

  const isAdminUser = ADMIN_ROLE_IDS.has(Number(user?.role_id));
  // Only show debug if showDebug is explicitly true
  // Admin users must also have showDebug enabled
  const canSeeDebug = user?.showDebug === true;

  // // Debug logging
  // console.log('useTableDebug:', {
  //   userId: user?.id,
  //   roleId: user?.role_id,
  //   isAdminUser,
  //   showDebug: user?.showDebug,
  //   showDebugType: typeof user?.showDebug,
  //   canSeeDebug
  // });

  const toggleDebug = () => {
    setIsDebugVisible(!isDebugVisible);
  };

  const fetchApiDocumentation = async (serviceMethod: () => Promise<any>) => {
    if (!canSeeDebug) return;

    try {
      const res = await serviceMethod();
      setApiDocumentation(res.data);
    } catch (err) {
      console.warn('Could not fetch API documentation:', err);
    }
  };

  const fetchSqlDocumentation = async (serviceMethod: () => Promise<any>) => {
    if (!canSeeDebug) return;

    try {
      const res = await serviceMethod();
      setSqlDocumentation(res.data);
    } catch (err) {
      console.warn('Could not fetch SQL documentation:', err);
    }
  };

  const fetchDebugInfo = async (
    apiServiceMethod: () => Promise<any>,
    sqlServiceMethod: () => Promise<any>
  ) => {
    if (!canSeeDebug) return;

    try {
      const [apiRes, sqlRes] = await Promise.all([apiServiceMethod(), sqlServiceMethod()]);
      setApiDocumentation(apiRes.data);
      setSqlDocumentation(sqlRes.data);
    } catch (err) {
      console.warn('Could not fetch debug documentation:', err);
    }
  };

  return {
    isDebugVisible,
    isAdminUser,
    canSeeDebug,
    apiDocumentation,
    sqlDocumentation,
    toggleDebug,
    fetchApiDocumentation,
    fetchSqlDocumentation,
    fetchDebugInfo,
  };
};
